import { Typography, Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import DeleteIcon from "../../../assets/icons/DeleteIcon.png";
import FileUploadDark from "../../../assets/icons/FileUploadDark.png";
import CheckCircle from "../../../assets/icons/CheckCircle.png";
import { LinkButton, SecondaryButton } from "../../../common/Buttons";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import "./status-quo-fileupload.scss";
import {
  getUploadedDoc,
  getUserStatusQuo,
  uploadDocument,
  deleteDocument,
  postStatusQuo,
} from "../../../services/yourWishes";
import { useNavigate } from "react-router-dom";
import { S3_URL } from "../../../constants/ApiUrls";
import {
  getKeyFromText,
  getUserIdFromLocalStorage,
} from "../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";
import { Toaster, toast } from "react-hot-toast";

const StatusQuoFileupload = ({ next, pre }) => {
  const { t } = useTranslation();
  let uID = getUserIdFromLocalStorage();
  const navigate = useNavigate();
  const [document, setDocument] = useState({});
  const [userStatusQuoList, setUserStatusQuoList] = useState([]);

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 6,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#957ba0" : "#308fe8",
    },
  }));

  const getUserStatusQuoList = async () => {
    const result = await getUserStatusQuo(uID);
    if (result?.success) {
      let userStatusQuo = [];
      result.payLoad.forEach((elem) => {
        userStatusQuo = [
          ...userStatusQuo,
          { ...elem, statusQuo: { ...elem.statusQuo, isLoading: false } },
        ];
      });
      setUserStatusQuoList(userStatusQuo);
    }
  };

  const handleFileUpdate = (e, key, focusedElement) => {
    let array = [];
    userStatusQuoList.forEach((elem) => {
      if (elem.statusQuo.statusQuoId === focusedElement.statusQuoId) {
        array = [
          ...array,
          { ...elem, statusQuo: { ...elem.statusQuo, isLoading: true } },
        ];
      } else {
        array = [...array, elem];
      }
    });
    setUserStatusQuoList(array);
    const filter = {
      statusQuoMediaFile: e.target.files[0],
      userStatusQuoId: key,
    };
    const formData = new FormData();
    Object.entries(filter).forEach(([key, value]) => {
      formData.append(key, value);
    });
    uploadDocumentFun(formData);
    e.target.value = "";
  };

  const uploadDocumentFun = async (payload) => {

    const result = await uploadDocument(payload, uID);
    if (result.success) {
      getUserStatusQuoList();
    } else {
      toast.error('Invalid file extension. Allowed files pdf,jpeg,jpg,png');
      getUserStatusQuoList();

    }
  };
  

  const handleDeleteDoc = async (id) => {
    const result = await deleteDocument(id, uID);
    if (result.success) {
      getUserStatusQuoList();
    }
  };

  useEffect(() => {
    getUserStatusQuoList();
  }, []);

  const handleDelete = async (statusQuoId) => {
    const result = await postStatusQuo(
      [
        ...userStatusQuoList.map((elem) => {
          if (elem?.statusQuo?.statusQuoId === statusQuoId) {
            return {
              statusQuoId,
              isWishChecked: false,
              isStatusQuoChecked: false,
            };
          }
          return {
            statusQuoId: elem.statusQuo.statusQuoId,
            isWishChecked: elem.isWishChecked,
            isStatusQuoChecked: elem.isStatusQuoChecked,
          };
        }),
      ],
      uID
    );
    if (result?.success) {
      getUserStatusQuoList();
    }
  };
  return (
    <Box
      component="div"
      className="status-quo-container"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      height="75vh"
      
    >
      <Toaster />

      <Box width="100%">
        <Box textAlign="center">
          <Typography
            variant="h4"
            marginTop="0.5rem"
            color="color.magentaDark2"
            fontWeight="600"
          >
            {t("sidebar-2-text-1")}
          </Typography>
          <Typography marginTop="0.6rem">{t("sq-upload-docs")}</Typography>
        </Box>
        <Box
          width="100%"
          height="50vh"
          overflow="auto"
          marginTop="28px"
          className="summary-table"
      
        >
          {userStatusQuoList?.map((elem, index) => {
            return (
              <>
                {elem?.isStatusQuoChecked &&
                  elem?.statusQuo?.isDocumentsAllowed && (
                    <Grid container className="sub-container-1" key={index}>
                      <Grid item xs={6}>
                        <Box compoment="div" className="block-1">
                          <Box
                            component="div"
                            width="45px"
                            display={
                              elem?.statusQuoMedias.length > 0
                                ? "block"
                                : "none"
                            }
                            
                          >
                            <img src={CheckCircle} />
                          </Box>
                          <Box component="div" className="field-1" >
                            <Typography variant="label" color="color.dimGrey">
                              {t(getKeyFromText(elem.statusQuo.title))}
                            </Typography>
                          </Box>
                          <Box
                            component="div"
                            marginLeft="20px"
                            marginRight="5px"
                            onClick={() =>
                              handleDelete(elem.statusQuo.statusQuoId)
                            }
                            sx={{
                                  cursor: 'pointer',
                                }}
                          >
                            <img src={DeleteIcon} />
                          </Box>
                          {elem.statusQuo.isLoading ? (
                            <Circles color="#dfc8db" height={30} width={30} />
                          ) : (
                            <Box
                              component="div"
                              marginLeft="15px"
                              position="relative"
                              cursor="pointer"
                            >
                              <input
                                className="input"
                                type="file"
                                onChange={
                                  elem?.statusQuoMedias.length === 3
                                    ? undefined
                                    : (e) =>
                                        handleFileUpdate(
                                          e,
                                          elem.userStatusQuoId,
                                          elem.statusQuo
                                        )
                                }
                                onClick={(event) => {
                                  event.target.value = null;
                                }}
                                
                              />
                              <img
                                src={FileUploadDark}
                                style={{
                                  opacity:
                                    elem?.statusQuoMedias.length === 3
                                      ? "0.5"
                                      : "1",
                                }}
                              
                              />
                            </Box>
                          )}
                        </Box>
                      </Grid>
                      <Grid item xs={6}>
                        {elem?.statusQuoMedias?.map((ele) => {
                          return (
                            <Box component="div" className="block-2">
                              <Typography
                                variant="p"
                                fontSize="12px"
                                color="color.dimGrey"
                              >
                                <a
                                  href={`${S3_URL}${ele.s3StorageFilename}`}
                                  target="_blank"
                                >
                                  {ele.originalFilename}
                                </a>
                              </Typography>
                              <Box
                                component="div"
                                className="progress-bar-container"
                              >
                                <BorderLinearProgress
                                  variant="determinate"
                                  value={100}
                                  className="progress-bar"
                                />
                                <Typography
                                  variant="p"
                                  className="remove-btn"
                                  onClick={() =>
                                    handleDeleteDoc(ele.statusQuoMediaId)
                                  }
                                >
                                  {t("remove")}
                                </Typography>
                              </Box>
                            </Box>
                          );
                        })}
                      </Grid>
                    </Grid>
                  )}
              </>
            );
          })}
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <SecondaryButton
          title={t("back")}
          bgColor="color.transparent"
          borderRadius="14px"
          width="180px"
          marginLeft="20px"
          border="1px solid #dfc8db"
          hoverBgColor="color.magentaLight1"
          click={pre}
          textTransform="initial"
          padding="0rem"
          height="2.7rem"
        />
        <SecondaryButton
          title={t("save-and-continue")}
          bgColor="#E8D7E5"
          borderRadius="14px"
          width="180px"
          marginLeft="10px"
          border="none"
          hoverBgColor="color.magentaLight1"
          click={() => {
            navigate("/your-wishes/your-wishes");
          }}
          textTransform="initial"
          padding="0rem"
          height="2.7rem"
        />
        <LinkButton
          title={t("skip-for-now")}
          bgColor="color.transparent"
          borderRadius="14px"
          fontSize="0.8rem"
          width="100px"
          marginLeft="10px"
          padding="0"
          border="none"
          click={() => navigate("/your-wishes/your-wishes")}
          textTransform="initial"
        />
      </Box>
    </Box>
  );
};

export default StatusQuoFileupload;
